/** Logical canvas (16:9 scene overlay). */
export const SPOTTING_OBJECTS_LOGICAL_WIDTH = 1920;
export const SPOTTING_OBJECTS_LOGICAL_HEIGHT = 1080;

export const SPOTTING_OBJECTS_BACKGROUND_SRC = '/minigames/lookingglass.jpg';

/** Server `minigames.spottingObjects.orderDisplayScale` */
export const SPOTTING_OBJECTS_ORDER_DISPLAY_SCALE = 0.01;

/** Server `surfaces.treetop.winReward.billyBucksAmount` */
export const SPOTTING_OBJECTS_BILLY_BUCKS_AMOUNT = 250;

/** Magnifier zoom inside the cursor circle (2.16× = +116% vs scene base). */
export const SPOTTING_OBJECTS_MAGNIFIER_ZOOM = 2.16;

/** Radius of the black cursor circle (logical px at 1920×1080 reference). */
export const SPOTTING_OBJECTS_MAGNIFIER_RADIUS_PX = 88;
